class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    const handle = this.dataset.handle;
    if (handle) this.trackProduct(handle);
    const handles = this.getHandles().filter(h => h !== handle);
    if (!handles.length) { this.remove(); return; }
    this.renderProducts(handles.slice(0, parseInt(this.dataset.limit) || 4));
  }

  trackProduct(handle) {
    let list = this.getHandles().filter(h => h !== handle);
    list.unshift(handle);
    list = list.slice(0, 12);
    try { localStorage.setItem('oft-rv', JSON.stringify(list)); } catch(e) {}
  }

  getHandles() {
    try { return JSON.parse(localStorage.getItem('oft-rv') || '[]'); }
    catch { return []; }
  }

  async renderProducts(handles) {
    const ul = this.querySelector('ul');
    if (!ul) return;
    const promises = handles.map(handle =>
      fetch('/products/' + handle + '.js')
        .then(r => r.json())
        .then(p => this.createCard(p))
        .catch(() => null)
    );
    const cards = (await Promise.all(promises)).filter(Boolean);
    if (!cards.length) { this.remove(); return; }
    cards.forEach(card => ul.appendChild(card));
    this.classList.remove('hidden');
  }

  createCard(product) {
    const li = document.createElement('li');
    li.className = 'grid__item';
    const price = (product.price / 100).toFixed(2);
    const comparePrice = product.compare_at_price ? (product.compare_at_price / 100).toFixed(2) : null;
    const img = product.featured_image || '';
    const imgTag = img ? '<div class="media media--transparent media--adapt"><img src="' + img + '&width=400" alt="' + product.title.replace(/"/g, '&quot;') + '" loading="lazy" width="400" height="400"></div>' : '';
    const priceHTML = (comparePrice && parseFloat(comparePrice) > parseFloat(price))
      ? '<div class="price price--on-sale"><span class="price-item price-item--sale">£' + price + '</span><s class="price-item price-item--regular">£' + comparePrice + '</s></div>'
      : '<div class="price"><span class="price-item price-item--regular">£' + price + '</span></div>';
    li.innerHTML = '<div class="card-wrapper product-card-wrapper"><div class="card card--standard"><div class="card__inner"><a href="/products/' + product.handle + '" class="card__media">' + imgTag + '</a></div><div class="card__content"><div class="card__information"><h3 class="card__heading h5"><a href="/products/' + product.handle + '" class="full-unstyled-link">' + product.title + '</a></h3>' + priceHTML + '</div></div></div></div>';
    return li;
  }
}
if (!customElements.get('recently-viewed-products')) {
  customElements.define('recently-viewed-products', RecentlyViewedProducts);
}